import type {
  IBillingProfileDataWeb,
  IBillingProfileData,
  IUpdateBillingProfileBody,
  BillingCustomerType,
} from '@/app-package';
import type { AxiosResponse } from 'axios';
import axios from 'axios';

/** Update the billing profile associated with a customer in BillingPlatform.
 * Optionally indicate whether this was triggered by a customer making a payment. */
export const updateBillingProfile = async ({
  billingProfile,
  billingCustomerType,
  logNewPayment,
}: {
  billingProfile: IBillingProfileData;
  billingCustomerType: BillingCustomerType;
  logNewPayment?: boolean;
}): Promise<IBillingProfileDataWeb> => {
  const { data } = await axios.post<
    IBillingProfileDataWeb,
    AxiosResponse<IBillingProfileDataWeb>,
    IUpdateBillingProfileBody
  >('/billing/billing_profile/', {
    billingProfile,
    logNewPayment,
    billingCustomerType,
  });
  return data;
};
